export function formatPrice(countryCode: string, price: number): string {
    return new Intl.NumberFormat(`de-${countryCode}`, {
        style: 'currency',
        currency: countryCode === 'CH' || countryCode === 'LI' ? 'CHF' : 'EUR',
    }).format(price);
}
